import { createAction, props } from '@ngrx/store';

import { LoginData, LoginResponse, FixaResource, SelectedContractDetails } from '../../models/login.model';
import { UserByUuidResponse } from '../../models/user.model';

// Login Actions
export const login = createAction(
  '[User] Login',
  props<{ credentials: any }>()
);
export const loginSuccess = createAction(
  '[User] Login Success',
  props<{ response: LoginResponse }>()
);
export const loginFailure = createAction(
  '[User] Login Failure',
  props<{ error: string }>()
);

// User Details Actions
export const loadUserDetails = createAction(
  '[User] Load User Details',
  props<{ uuid: string }>()
);
export const loadUserDetailsSuccess = createAction(
  '[User] Load User Details Success',
  props<{ user: UserByUuidResponse }>()
);
export const loadUserDetailsFailure = createAction(
  '[User] Load User Details Failure',
  props<{ error: string }>()
);

// Logout Actions
export const logout = createAction('[User] Logout');
export const logoutSuccess = createAction('[User] Logout Success');

// Loading Actions
export const setLoading = createAction(
  '[User] Set Loading',
  props<{ loading: boolean }>()
);

// Select CNPJ Actions
export const selectCnpj = createAction(
  '[User] Select CNPJ',
  props<{ document: string }>()
);

// Select Contract (Fixa) Actions
export const selectContract = createAction(
  '[User] Select Contract',
  props<{ contract: FixaResource }>()
);

export const selectContractSuccess = createAction(
  '[User] Select Contract Success',
  props<{ contractDetails: SelectedContractDetails }>()
);

export const updateLoginData = createAction(
  '[User] Update Login Data',
  props<{ loginData: Partial<LoginData> }>()
);
